import { useEffect, useState, type ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { currentUser, type SwaUser } from "../lib/api";

/**
 * Admin shell. The data is protected by the API (SWA role + ADMIN_EMAILS);
 * this component only sends anonymous visitors to the Microsoft sign-in.
 */
export function AdminLayout({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<SwaUser | null | undefined>(undefined);
  useEffect(() => {
    void currentUser().then((u) => {
      if (!u) window.location.href = "/login";
      setUser(u);
    });
  }, []);

  if (!user) return <p className="container muted">Verificando sesión…</p>;

  return (
    <>
      <header className="topbar">
        <strong>CoolTesters Business · Admin</strong>
        <nav>
          <NavLink to="/admin" end>
            Cotizaciones
          </NavLink>
          <NavLink to="/admin/catalog">Catálogo</NavLink>
          <span className="topbar-user">{user.userDetails}</span>
          <a href="/.auth/logout?post_logout_redirect_uri=/">Salir</a>
        </nav>
      </header>
      <main className="container">{children}</main>
    </>
  );
}

export function ErrorBox({ message }: { message: string | null }) {
  if (!message) return null;
  return (
    <p className="error" role="alert">
      {message}
    </p>
  );
}
